import { Card, CardContent, CardProps, Grid } from '@mui/material';
import { FC } from 'react';

import { CardTitleWithEdit } from '../../../../components/cardTitleWithEdit/CardTitleWithEdit';
import { entityToDTO } from '../../../../components/editUtils';
import { useNavigateDialogForm } from '../../../../components/formikDialogForm/dialogForm.hook';
import { TextDisplay } from '../../../../components/TextDisplay/TextDisplay';
import { useMitarbeiterRole } from '../../../auth/api/auth.hook';
import { MitarbeiterRole } from '../../../auth/api/types';
import { KundeDisplay } from '../../../kunde/components/KundeDisplay';
import { KundeLink } from '../../../kunde/components/KundeLink';
import { Projekt } from '../../api/projekt.types';

interface ProjektStammdatenCardProps {
  projekt: Projekt;
  cardProps?: CardProps;
  withKundePopover?: boolean;
}

export const ProjektStammdatenCard: FC<ProjektStammdatenCardProps> = ({
  projekt,
  cardProps,
  withKundePopover,
}) => {
  const navigateDialog = useNavigateDialogForm('projektStammdaten', 'edit', entityToDTO(projekt));
  const userRole = useMitarbeiterRole();
  return (
    <Card {...cardProps}>
      <CardContent>
        <CardTitleWithEdit
          title={projekt.istArchiviert ? 'Stammdaten [Archiviert]' : 'Stammdaten'}
          optionLabel={'Stammdaten bearbeiten'}
          onClickEdit={userRole === MitarbeiterRole.ADMIN ? navigateDialog : undefined}
        />
        <Grid container spacing={2}>
          <Grid size={6}>
            <TextDisplay label="Projektname" value={projekt.name} />
          </Grid>
          <Grid size={6}>
            {withKundePopover ? (
              <KundeDisplay id={projekt.kundeId} label="Kunde" />
            ) : (
              <KundeLink id={projekt.kundeId} label="Kunde" />
            )}
          </Grid>
          <Grid size={6}>
            <TextDisplay label="Kurzbeschreibung" value={projekt.kurzbeschreibung} />
          </Grid>
          <Grid size={6}>
            <TextDisplay
              label="Rechnungszyklus"
              value={projekt.rechnungszyklus as unknown as string}
            />
          </Grid>
          {projekt.bemerkung && (
            <Grid size={12}>
              <TextDisplay label="Bemerkung" value={projekt.bemerkung} />
            </Grid>
          )}
          <Grid size={4}>
            <TextDisplay label="Pauschal" value={projekt.istPauschal ? 'Ja' : 'Nein'} />
          </Grid>
          <Grid size={4}>
            <TextDisplay label="Pausiert" value={projekt.istPausiert ? 'Ja' : 'Nein'} />
          </Grid>
          <Grid size={4}>
            <TextDisplay label="Status" value={projekt.istArchiviert ? 'archiviert' : 'aktiv'} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
